import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";

export default function AreaHero({ area }) {
  const Icon = Icons[area.icon] || Icons.Scale;
  return (
    <section className="bg-[#11203c] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)", backgroundSize: "32px 32px" }} />
      <div className="relative max-w-6xl mx-auto px-6 py-16 md:py-24">
        <nav className="text-xs uppercase tracking-[0.25em] text-[#a8c4dc] flex items-center gap-2" aria-label="Breadcrumb" data-testid="breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link><span>/</span>
          <Link to="/#practice" className="hover:text-white">Practice Areas</Link><span>/</span>
          <span className="text-[#d4b87a]">{area.title}</span>
        </nav>
        <div className="flex items-start gap-5 mt-8">
          <div className="hidden sm:flex shrink-0 w-14 h-14 border border-[#d4b87a] items-center justify-center"><Icon className="w-6 h-6 text-[#d4b87a]" /></div>
          <div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight" data-testid="area-title">{area.title}</h1>
            <p className="text-stone-300 text-base md:text-lg mt-5 max-w-3xl leading-relaxed">{area.summary}</p>
            <div className="text-sm text-[#a8c4dc] mt-4">Serving Nampa, Meridian, Boise, Caldwell, and all of Idaho</div>
          </div>
        </div>
      </div>
    </section>
  );
}
